"use client";
import React from "react";
import Link from "next/link";

import {Media, Product} from "../../../../payload/payload-types";

import classes from "./index.module.scss";
import { Price } from "../../../../../src/app/_components/Price";
import Image from "next/image";
import SalesOffPercentage from "../../SalesOffPercentage";

type ProductCardProps = {
  product: Product;
};

const BrandProductsCard = (product) => {
  const media = product?.products?.meta?.image as Media;
  return (
      <Link
          href={product.products.slug}
          className={classes.card}
      >
        <div className={classes.mediaWrapper}>
          {!media && <div className={classes.placeholder}>No image</div>}
          {media && typeof media !== "string" && (
              <Image
                  className={classes.image}
                  src={`${media.url}`}
                  alt={`${media.alt}`}
                  blurDataURL={`${media.url}`}
                  placeholder={"blur"}
                  loading="lazy"
                  fill={true}
                  sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
              />
          )}
        </div>
        <span className={classes.productTitle}>{product.products.title}</span>
        {/*<SalesOffPercentage product={product.products}/>*/}
        <Price product={product.products} button={false}/>
        {/*<img*/}
        {/*  className={classes.brandImg}*/}
        {/*  alt={product.products.title}*/}
        {/*  src={media}*/}
        {/*/>*/}
        {/*<span className={classes.productTitle}>{product.products.title}</span>*/}
        {/*/!* <span className={classes.productDescription}>{product.products.meta.description}</span> *!/*/}
        {/*<Price*/}
        {/*  product={product.products}*/}
        {/*  button="addToCart"*/}
        {/*/>*/}
      </Link>
  );
};

export default BrandProductsCard;
